import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { motion } from "framer-motion";
import { X, ScrollText } from "lucide-react";

export default function CollectionsModal({ open, conversationId, conversationName, onClose }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!open || !conversationId) return;
    (async () => {
      try {
        const { data } = await api.get(`/conversations/${conversationId}/collections`);
        setData(data);
      } catch {}
    })();
  }, [open, conversationId]);

  if (!open) return null;

  const cards = data ? [
    { label: "Toplam mesaj", value: data.total_messages, emoji: "💬", bg: "#CCFF00" },
    { label: "Sesli notlar", value: data.voice_messages, emoji: "🎤", bg: "#FF9E80" },
    { label: "Çizimler", value: data.doodle_messages, emoji: "🎨", bg: "#D4B3FF" },
    { label: "Toplam karakter", value: data.total_chars, emoji: "🔡", bg: "#A8E6FF" },
    { label: "Aktif gün", value: data.unique_days, emoji: "📅", bg: "#FFF7C2" },
  ] : [];

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4" data-testid="collections-modal">
      <div className="bg-white border-hard shadow-hard-lg rounded-2xl w-full max-w-xl p-6 slide-up max-h-[85vh] overflow-auto">
        <div className="flex items-center justify-between mb-3">
          <h2 className="font-display text-2xl flex items-center gap-2"><ScrollText strokeWidth={3} className="w-6 h-6" /> Sohbet Koleksiyonu</h2>
          <button onClick={onClose} data-testid="collections-close-btn" className="w-9 h-9 border-hard-2 rounded-lg flex items-center justify-center press-btn">
            <X strokeWidth={3} className="w-4 h-4" />
          </button>
        </div>
        <p className="text-sm text-[#555] mb-4"><b>{conversationName}</b> sohbetinin istatistikleri</p>

        {!data && <div className="text-center py-8 font-semibold">Yükleniyor…</div>}

        {data && (
          <>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
              {cards.map((c, i) => (
                <motion.div
                  key={c.label}
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ delay: i * 0.05 }}
                  className="border-hard-2 rounded-xl p-3 shadow-hard-sm"
                  style={{ background: c.bg }}
                >
                  <div className="text-xl">{c.emoji}</div>
                  <div className="font-display text-2xl leading-none mt-1">{c.value}</div>
                  <div className="text-[10px] font-black uppercase tracking-widest mt-1">{c.label}</div>
                </motion.div>
              ))}
            </div>

            {data.top_emojis?.length > 0 && (
              <div className="mt-4 border-hard-2 rounded-xl p-3">
                <div className="text-xs uppercase font-black tracking-widest mb-2">En çok kullanılan emojiler</div>
                <div className="flex items-center gap-2 flex-wrap">
                  {data.top_emojis.map((e) => (
                    <div key={e.emoji} className="border-hard-2 rounded-full px-3 py-1 bg-white">
                      <span className="text-lg">{e.emoji}</span>
                      <span className="text-xs font-black ml-1">{e.count}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {data.longest_day && (
              <div className="mt-3 border-hard-2 rounded-xl p-3 bg-[#F9F8F6]">
                <div className="text-xs uppercase font-black tracking-widest">En hareketli gün</div>
                <div className="font-black">{data.longest_day.date} — <span className="text-[#E43385]">{data.longest_day.count} mesaj</span></div>
              </div>
            )}

            {data.top_sender && (
              <div className="mt-3 border-hard-2 rounded-xl p-3 bg-[#F9F8F6]">
                <div className="text-xs uppercase font-black tracking-widest">Şampiyon konuşmacı</div>
                <div className="font-black">{data.top_sender.name} — <span className="text-[#5C9A00]">{data.top_sender.count} mesaj</span></div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
